@if (loadingProgressService.loading$ | async) {
  <div class="loading-overlay">
    <div class="loading-spinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p>
        {{ "components.shared.loading" | translate }}
      </p>
    </div>
  </div>
}
